module.exports = __webpack_public_path__ + "img/95.6.CODm.fa3c131f.png";